<template>
  <div class="col-12">
    <h1 class="page-title" v-if="protocolVuexData">{{'protocol.protocol' | trans}}: {{protocolVuexData.protocol.title}}</h1>
    <div class="row mt-2 mb-3" v-if="isPreviousDateSession && protocolVuexData && protocolVuexData.endDate" ref="maxTotalAtemptsCountError" id="maxTotalAtemptsCountError">
      <div class="col-12">
        <div class="alert-danger text-center" v-if="showDatePrevious">
          {{'protocol.enter_another_session_date' | trans}} <strong>{{minDate | toLocaleDateTime}}</strong>
        </div>
        <div class="alert-secondary text-center" v-if="!showDatePrevious">
          {{'protocol.end_session_date' | trans}}: <strong>{{minDate | toLocaleDateTime}}</strong>
        </div>
      </div>
    </div>
    <h2 class="second-title" v-if="stage">
      {{'protocol.stage' | trans}}: {{stage.description}}

      <button
          @click="closeSession()"
          v-if="isBCBA || isCurator"
          class="btn btn-primary float-md-right">
        {{'protocol.buttons.finishStage' | trans}}
      </button>

    </h2>
    <h3 class="page-sub-title mt-3 mt-md-0">{{'protocol.choose_phase' | trans}}</h3>
  </div>
</template>

<script>
  import {mapGetters, mapState} from 'vuex';
  import moment from 'moment';

  export default {
    name: 'StageHeader',
    props:{
      'stage': null,
      'stageCount': null
    },
    computed: {
      ...mapState([
        'route',
      ]),
      ...mapGetters('auth', [
        'isBCBA',
        'isCurator',
        'isPreviousDateSession',
        'previousDate',
        'previousTime',
        'previousDuration'
      ]),

      ...mapState('protocol', [
        'protocolVuexData',
      ]),

      minDate() {
        return this.protocolVuexData.endDate ? moment(this.protocolVuexData.endDate.date, 'YYYY-MM-DD HH:mm').toDate() : null;
      },

      showDatePrevious() {
        if (this.protocolVuexData.endDate && this.previousDate && this.isPreviousDateSession && this.previousTime && this.previousTime.HH && this.previousTime.mm){

          let protocolDate = moment(this.minDate).unix();
          let sessionDate = new Date(this.previousDate.getFullYear(),
              this.previousDate.getMonth(),
              this.previousDate.getDate(),
              this.previousTime.HH,
              this.previousTime.mm);

          let previous = moment(sessionDate).unix();
          return previous <= protocolDate;

        }

        return false;
      },
    },
    methods:{
      closeSession(){
        this.$emit('close-session');
      }
    },
    watch: {
      previousDate(newValue){
        this.$emit('fetch-protocol');
      },
      previousTime(newValue){
        if (this.showDatePrevious) {
          this.$emit('fetch-protocol');
        }
      },
      isPreviousDateSession(newValue){
        if (!newValue){
          this.$emit('fetch-protocol');
        }
      }

    }
  }
</script>


// WEBPACK FOOTER //
// src/modules/dashboardParent/components/StageHeader.vue